(function(){

  'use strict';

  function help($filter, $timeout, $rootScope) {
    return {
      restrict: 'EA',
      scope: {
        helpCaption: '=helpCaption'
      },
      templateUrl: 'app/directives/helpDirective/help.template.html',
      link: function(scope, element, attrs) {

        var unformatedHelpContent = null;
        var openHelp = false;

        //*****************//
        // $watch
        // -----------------
        // Watching for value changes & null in scope.helpCaption
        //*****************//
        scope.$watch(function() {
          return scope.helpCaption;
        }, function(newVal, oldVal) {
          if (!angular.equals(newVal, oldVal)) {
            init();
          } else if (unformatedHelpContent === null) {
            init();
          }
        }, true)

        //*****************//
        // INIT
        // -----------------
        // Translates the caption
        // Removes unwanted mark-up
        // Show helpModule if valid content
        //*****************//
        function init () {
          $timeout(function() {
            if($rootScope.TenantListService?.currentTenant?.isPowerPDFOnly()) {
              scope.helpCaption = "HelpPowerPDF";
            }
            unformatedHelpContent = $filter("translate")(scope.helpCaption);
            unformatedHelpContent = unformatedHelpContent.replace(/<\/br\s*[\/]?>/gi, '');
            if (unformatedHelpContent !== scope.helpCaption) {
              captionIncomplete(unformatedHelpContent);
            } else {
              angular.element('.help-container').hide();
            }
          }, 200)
        }

        //*****************//
        // captionIncomplete()
        //*****************//
        function captionIncomplete(unformatedHelpContent){
          scope.helpContent = $filter("translate")(unformatedHelpContent);
          angular.element('.help-container').show();
        }

        scope.toggleHelp = function() {
          openHelp = !openHelp;
          if (openHelp) {
            angular.element('.help-container').addClass('help-open');
          } else {
            angular.element('.help-container').removeClass('help-open');
          }
        }

        scope.closeThis = function() {
          openHelp = false;
          angular.element('.help-container').removeClass('help-open');
        }

      }
    };
  }

  help.$inject = ['$filter', '$timeout', '$rootScope'];

  angular
    .module('printix-admin')
    .directive('help', help);

})();
